<template>
  <div class="reserve-new">
    <!-- 顶部导航栏 -->
    <div class="nav-header">
      <van-nav-bar 
        title="贵宾厅预约" 
        left-arrow 
        @click-left="$router.back()"
        :border="false"
      >
        <template #title>
          <div class="nav-title">
            <i class="title-icon">✈️</i>
            <span>贵宾厅预约</span>
          </div>
        </template>
      </van-nav-bar>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 选择区域卡片 -->
      <div class="selection-card" v-show="!showVipList">
        <div class="card-header">
          <h2>开启您的贵宾之旅</h2>
          <p>享受舒适、安静的候机体验</p>
        </div>

        <!-- 机场选择 -->
        <div class="form-item" :class="{ 'item-selected': airportName && airportName !== '请选择机场' }">
          <div class="item-label">
            <i class="icon">🏢</i>
            <span>出发机场</span>
          </div>
          <div class="item-value" @click="openAirportPicker">
            <span :class="{ placeholder: !airportName || airportName === '请选择机场' }">
              {{ airportName || '请选择机场' }}
            </span>
            <van-icon name="arrow" />
          </div>
        </div>

        <!-- 日期选择 -->
        <div class="form-item" :class="{ 'item-selected': orderForm.memberServiceOrder.usageTime }">
          <div class="item-label">
            <i class="icon">📅</i>
            <span>使用日期</span>
          </div>
          <div class="item-value" @click="openDatePicker">
            <span :class="{ placeholder: !orderForm.memberServiceOrder.usageTime }">
              {{ orderForm.memberServiceOrder.usageTime || '请选择日期' }}
            </span>
            <van-icon name="arrow" />
          </div>
        </div>

        <!-- 搜索贵宾厅按钮 -->
        <div class="search-btn" @click="searchVipHalls" :class="{ disabled: !canSearch }">
          <div class="btn-content">
            <i class="search-icon">🔍</i>
            <span>搜索贵宾厅</span>
          </div>
        </div>
      </div>

      <!-- 贵宾厅列表 -->
      <div class="vip-list" v-show="showVipList">
        <!-- 筛选栏 -->
        <div class="filter-bar">
          <div class="location-info">
            <i class="location-icon">📍</i>
            <span>{{ airportName }}</span>
            <span class="date">{{ orderForm.memberServiceOrder.usageTime }}</span>
          </div>
          <div class="back-btn" @click="backToSelection">
            <van-icon name="arrow-left" />
            <span>重新选择</span>
          </div>
        </div>

        <!-- 贵宾厅卡片列表 -->
        <div class="vip-cards">
          <div 
            class="vip-card" 
            v-for="(item, index) in memberServiceList" 
            :key="item.id"
            :style="{ animationDelay: index * 0.1 + 's' }"
            @click="selectVipHall(item)"
          >
            <div class="card-image">
              <img :src="getHomeImage(item)" alt="" @error="handleImageError">
              <div class="price-tag">
                <span class="vip-price">¥{{ item.priceData[0]?.costPrice || 168 }}</span>
                <span class="original-price" v-if="item.priceData[0]?.marketPrice !== item.priceData[0]?.costPrice">
                  ¥{{ item.priceData[0]?.marketPrice || 150 }}
                </span>
              </div>
            </div>
            <div class="card-content">
              <h3>{{ item.productName }}</h3>
              <div class="time-info">
                <i class="time-icon">🕐</i>
                <span>{{ item.serverStime }} - {{ item.serverEtime }}</span>
              </div>
              <div class="location-info">
                <i class="location-icon">📍</i>
                <span>{{ item.addressDetail || '详情请咨询客服' }}</span>
              </div>
              <div class="usage-info" v-if="item.useMinute">
                <i class="clock-icon">⏰</i>
                <span>可使用{{ item.useMinute }}分钟</span>
              </div>
              <div class="features">
                <span 
                  class="feature-tag" 
                  v-for="feature in getServiceFeatures(item)" 
                  :key="feature.id"
                  :title="feature.value"
                >
                  <img :src="feature.url" :alt="feature.value" class="feature-icon" @error="handleIconError">
                  {{ feature.value }}
                </span>
              </div>
              <div class="remark" v-if="item.remark">
                <i class="info-icon">ℹ️</i>
                <span>{{ item.remark }}</span>
              </div>
            </div>
          </div>
          
          <!-- 空状态 -->
          <div class="empty-state" v-if="memberServiceList.length === 0">
            <i class="empty-icon">🏢</i>
            <p>当前时间段暂无可用贵宾厅</p>
            <span>请选择其他日期或联系客服</span>
          </div>
        </div>
      </div>


    </div>

    <!-- 机场选择弹窗 -->
    <van-popup v-model="airportShow" position="bottom" :style="{ height: '70%' }" round>
      <div class="popup-header">
        <h3>选择机场</h3>
        <div class="search-box">
          <van-icon name="search" />
          <input 
            type="text" 
            v-model="placekey" 
            placeholder="搜索机场"
            class="search-input"
          />
        </div>
      </div>
      <div class="airport-list">
        <div 
          class="airport-item" 
          v-for="item in (searchList.length > 0 ? searchList : airportList)"
          :key="item.id"
          @click="selectAirport(item)"
        >
          <i class="airport-icon">🛫</i>
          <div class="airport-info">
            <span class="airport-name">{{ item.airportName }}</span>
            <span class="airport-code">{{ item.threeWord }}</span>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 日期选择器 -->
    <van-calendar
      v-model="calendarShow"
      color="#1989fa"
      :show-confirm="false"
      @confirm="selectDate"
      :max-date="maxDate"
      :min-date="new Date()"
    />
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'ReserveNew',
  data() {
    return {
      // 显示状态
      showVipList: false,
      airportShow: false,
      calendarShow: false,
      
      // 选中的数据
      airportName: '',
      airportCode: '',
      selectedVipHall: null,
      
      // 表单数据
      orderForm: {
        memberServiceOrder: {
          memberServiceId: '',
          usageTime: '',
          memberNo: '',
          linkmanTel: '',
          totalAmount: 0,
          realAmount: 0,
          costAmount: 0,
          orderAmount: 0
        },
        consumerList: [{
          name: '',
          nameFlag: false,
          tel: '',
          telFlag: false,
          idCardNum: '',
          idCardType: 1,
          idCardNumFlag: false,
          pwdCode: '',
          pwdCodeFlag: false,
          pwdCodeErr: ''
        }]
      },
      
      // 数据列表
      airportList: [],
      memberServiceList: [],
      searchList: [],
      
      // 搜索关键词
      placekey: '',
      
      // 验证规则
      phoneReg: /^[1][3,4,5,7,8,9][0-9]{9}$/,
      idCardReg: /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
      
      // 其他
      maxDate: new Date(2100, 0, 1),
      phoneFlag: false,
      marketPrice: 0
    }
  },
  
  computed: {
    canSearch() {
      return this.airportCode && this.orderForm.memberServiceOrder.usageTime;
    }
  },
  
  mounted() {
    this.initPage();
    this.queryUserAirportNew();
    
    // 调试信息
    if (this.$route.query.test) {
      console.log('🚀 新版预约页面已加载');
      console.log('📍 当前路由参数:', this.$route.query);
    }
  },
  
  methods: {
    // 初始化页面
    initPage() {
      const num = Number(this.$route.query.num) || 1;
      if (num > 1) {
        for (let i = 0; i < num - 1; i++) {
          this.handleAddPassenger();
        }
      }
      
      if (this.$route.query.vipId) {
        this.orderForm.memberServiceOrder.memberNo = this.$route.query.vipId;
      }
      
      if (this.$route.query.pwdCode) {
        const codes = JSON.parse(this.$route.query.pwdCode);
        codes.forEach((code, index) => {
          if (this.orderForm.consumerList[index]) {
            this.orderForm.consumerList[index].pwdCode = code;
          }
        });
      }
    },
    
    // 获取机场列表
    queryUserAirportNew() {
      this.request({
        url: '/product/sdAirportNew/queryUserAirportNew',
        method: 'get',
        params: { type: 1 }
      }).then(resp => {
        if (resp.code === 200) {
          this.airportList = resp.data;
          if (this.$route.query.test) {
            console.log('✈️ 机场列表加载成功:', resp.data.length + '个机场');
          }
        } else {
          this.$toast('获取机场列表失败，请重试');
        }
      }).catch(error => {
        console.error('获取机场列表失败:', error);
        this.$toast('网络异常，请检查网络连接');
      });
    },
    
    // 打开机场选择器
    openAirportPicker() {
      this.airportShow = true;
    },
    
    // 选择机场
    selectAirport(item) {
      this.airportName = item.airportName;
      this.airportCode = item.threeWord;
      this.airportShow = false;
    },
    
    // 打开日期选择器
    openDatePicker() {
      this.calendarShow = true;
    },
    
    // 选择日期
    selectDate(date) {
      this.orderForm.memberServiceOrder.usageTime = moment(date).format('YYYY-MM-DD');
      this.calendarShow = false;
    },
    
    // 搜索贵宾厅
    searchVipHalls() {
      if (!this.canSearch) {
        this.$toast('请先选择机场和日期');
        return;
      }
      
      // 显示加载提示
      const toast = this.$toast.loading({
        message: '正在搜索贵宾厅...',
        forbidClick: true,
      });
      
      this.request({
        url: '/product/productInfo/getProductByAirCodeAndTime',
        method: 'get',
        params: {
          vestedFirm: 1,
          airPortCode: this.airportCode,
          bookingTime: this.orderForm.memberServiceOrder.usageTime
        }
      }).then(res => {
        toast.clear();
        if (res.code === 200) {
          this.memberServiceList = res.data;
          this.showVipList = true;
          
          if (this.$route.query.test) {
            console.log('🏢 贵宾厅搜索成功:', res.data.length + '个贵宾厅');
          }
          
          if (res.data.length === 0) {
            this.$toast('当前时间段暂无可用贵宾厅');
          }
        } else {
          this.$toast(res.msg || '搜索失败，请重试');
        }
      }).catch(error => {
        toast.clear();
        console.error('搜索贵宾厅失败:', error);
        this.$toast('网络异常，请重试');
      });
    },
    
    // 返回选择页面
    backToSelection() {
      this.showVipList = false;
      this.selectedVipHall = null;
    },
    
    // 选择贵宾厅
    selectVipHall(item) {
      this.selectedVipHall = item;
      this.orderForm.memberServiceOrder.memberServiceId = item.id;
      this.marketPrice = item.priceData[0]?.marketPrice || 0;
      
      // 跳转到乘客信息填写页面
      this.$router.push({
        path: '/passenger-info',
        query: {
          vipHall: JSON.stringify(item),
          airport: this.airportName,
          orderForm: JSON.stringify(this.orderForm),
          num: this.orderForm.consumerList.length,
          pwdCode: this.$route.query.pwdCode || null
        }
      });
    },
    

    
    // 机场搜索
    getSearchPlace(keywords) {
      if (!keywords) {
        this.searchList = [];
        return;
      }
      
      this.searchList = this.airportList.filter(item =>
        item.airportName.includes(keywords)
      );
    },
    
    // 获取贵宾厅主图片
    getHomeImage(item) {
      if (item.imgData && item.imgData.length > 0) {
        // 优先显示homeTag为1的图片
        const homeImg = item.imgData.find(img => img.homeTag === 1);
        if (homeImg) return homeImg.imgUrl;
        
        // 如果没有homeTag为1的，显示第一张图片
        return item.imgData[0].imgUrl;
      }
      
      // 默认图片
      return require('@/assets/exchangebg.png');
    },
    
    // 获取服务设施列表
    getServiceFeatures(item) {
      if (!item.serverContent) return [];
      
      try {
        const serverContent = JSON.parse(item.serverContent);
        const features = [];
        
        // 合并所有服务项目
        if (serverContent.defaultList) {
          features.push(...serverContent.defaultList.slice(0, 6)); // 最多显示6个
        }
        if (serverContent.defaultfreeList && features.length < 6) {
          const remaining = 6 - features.length;
          features.push(...serverContent.defaultfreeList.slice(0, remaining));
        }
        if (serverContent.defaultchargeList && features.length < 6) {
          const remaining = 6 - features.length;
          features.push(...serverContent.defaultchargeList.slice(0, remaining));
        }
        
        return features;
      } catch (error) {
        console.error('解析服务内容失败:', error);
        return [];
      }
    },
    
    // 处理图片加载错误
    handleImageError(event) {
      event.target.src = require('@/assets/exchangebg.png');
    },
    
    // 处理服务图标加载错误
    handleIconError(event) {
      event.target.style.display = 'none';
    }
  },
  
  watch: {
    placekey(val) {
      this.getSearchPlace(val);
    }
  }
}
</script>

<style lang="less" scoped>
.reserve-new {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  
  .nav-header {
    position: sticky;
    top: 0;
    z-index: 100;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    
    .van-nav-bar {
      background: transparent;
      
      .nav-title {
        display: flex;
        align-items: center;
        gap: 8px;
        
        .title-icon {
          font-size: 20px;
        }
      }
    }
  }
  
  .main-content {
    padding: 20px;
    
    // 选择区域卡片
    .selection-card {
      background: rgba(255, 255, 255, 0.95);
      border-radius: 20px;
      padding: 24px;
      margin-bottom: 20px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(10px);
      animation: slideInUp 0.6s ease-out;
      
      .card-header {
        text-align: center;
        margin-bottom: 32px;
        
        h2 {
          font-size: 24px;
          font-weight: 600;
          color: #2c3e50;
          margin-bottom: 8px;
        }
        
        p {
          color: #7f8c8d;
          font-size: 14px;
        }
      }
      
      .form-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px;
        margin-bottom: 16px;
        background: #f8f9fa;
        border-radius: 12px;
        border: 2px solid transparent;
        transition: all 0.3s ease;
        cursor: pointer;
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
        
        &.item-selected {
          border-color: #1989fa;
          background: rgba(25, 137, 250, 0.05);
        }
        
        .item-label {
          display: flex;
          align-items: center;
          gap: 12px;
          
          .icon {
            font-size: 20px;
          }
          
          span {
            font-weight: 500;
            color: #2c3e50;
          }
        }
        
        .item-value {
          display: flex;
          align-items: center;
          gap: 8px;
          
          .placeholder {
            color: #bdc3c7;
          }
        }
      }
      
      .search-btn {
        background: linear-gradient(135deg, #1989fa 0%, #0984e3 100%);
        border-radius: 12px;
        padding: 16px;
        text-align: center;
        color: white;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        margin-top: 24px;
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(25, 137, 250, 0.3);
        }
        
        &.disabled {
          background: #bdc3c7;
          cursor: not-allowed;
          
          &:hover {
            transform: none;
            box-shadow: none;
          }
        }
        
        .btn-content {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          
          .search-icon {
            font-size: 18px;
          }
        }
      }
    }
    
    // 贵宾厅列表
    .vip-list {
      .filter-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: rgba(255, 255, 255, 0.95);
        padding: 16px 20px;
        border-radius: 12px;
        margin-bottom: 20px;
        backdrop-filter: blur(10px);
        
        .location-info {
          display: flex;
          align-items: center;
          gap: 8px;
          
          .location-icon {
            font-size: 16px;
          }
          
          .date {
            color: #7f8c8d;
            margin-left: 8px;
          }
        }
        
        .back-btn {
          display: flex;
          align-items: center;
          gap: 4px;
          color: #1989fa;
          cursor: pointer;
          font-size: 14px;
        }
      }
      
      .vip-cards {
        .vip-card {
          background: rgba(255, 255, 255, 0.95);
          border-radius: 16px;
          margin-bottom: 16px;
          overflow: hidden;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
          cursor: pointer;
          transition: all 0.3s ease;
          animation: slideInRight 0.5s ease-out both;
          
          &:hover {
            transform: translateY(-4px);
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
          }
          
          .card-image {
            position: relative;
            height: 120px;
            background: linear-gradient(45deg, #f093fb 0%, #f5576c 100%);
            
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            
            .price-tag {
              position: absolute;
              top: 12px;
              right: 12px;
              background: rgba(0, 0, 0, 0.8);
              color: white;
              padding: 8px 12px;
              border-radius: 20px;
              display: flex;
              align-items: center;
              gap: 8px;
              
              .vip-price {
                font-weight: 600;
                font-size: 16px;
              }
              
              .original-price {
                text-decoration: line-through;
                opacity: 0.7;
                font-size: 12px;
              }
            }
          }
          
          .card-content {
            padding: 16px;
            
            h3 {
              font-size: 18px;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 12px;
            }
            
            .time-info,
            .location-info,
            .usage-info {
              display: flex;
              align-items: center;
              gap: 8px;
              margin-bottom: 8px;
              color: #7f8c8d;
              font-size: 14px;
            }
            
            .usage-info {
              color: #e74c3c;
              font-weight: 500;
            }
            
            .features {
              display: flex;
              gap: 6px;
              flex-wrap: wrap;
              margin-top: 12px;
              
              .feature-tag {
                background: rgba(25, 137, 250, 0.1);
                color: #1989fa;
                padding: 4px 8px;
                border-radius: 12px;
                font-size: 11px;
                display: flex;
                align-items: center;
                gap: 4px;
                max-width: 120px;
                
                .feature-icon {
                  width: 12px;
                  height: 12px;
                  object-fit: contain;
                  flex-shrink: 0;
                }
              }
            }
            
            .remark {
              display: flex;
              align-items: flex-start;
              gap: 6px;
              margin-top: 12px;
              padding: 8px 12px;
              background: rgba(241, 196, 15, 0.1);
              border-radius: 8px;
              border-left: 3px solid #f1c40f;
              
              .info-icon {
                font-size: 12px;
                margin-top: 2px;
                flex-shrink: 0;
              }
              
              span {
                font-size: 12px;
                color: #e67e22;
                line-height: 1.4;
              }
            }
          }
        }
        
        .empty-state {
          text-align: center;
          padding: 60px 20px;
          background: rgba(255, 255, 255, 0.95);
          border-radius: 16px;
          backdrop-filter: blur(10px);
          
          .empty-icon {
            font-size: 48px;
            margin-bottom: 16px;
            display: block;
          }
          
          p {
            font-size: 16px;
            color: #2c3e50;
            margin-bottom: 8px;
            font-weight: 500;
          }
          
          span {
            font-size: 14px;
            color: #7f8c8d;
          }
        }
      }
    }
    

  }
  
  // 弹窗样式
  .popup-header {
    padding: 20px;
    border-bottom: 1px solid #ecf0f1;
    
    h3 {
      text-align: center;
      margin-bottom: 16px;
      color: #2c3e50;
    }
    
    .search-box {
      position: relative;
      
      .van-icon {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #bdc3c7;
      }
      
      .search-input {
        width: 100%;
        padding: 12px 12px 12px 40px;
        border: 1px solid #ecf0f1;
        border-radius: 8px;
        font-size: 14px;
        background: #f8f9fa;
        
        &:focus {
          outline: none;
          border-color: #1989fa;
        }
      }
    }
  }
  
  .airport-list {
    max-height: 400px;
    overflow-y: auto;
    
    .airport-item {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 16px 20px;
      border-bottom: 1px solid #ecf0f1;
      cursor: pointer;
      transition: background 0.2s;
      
      &:hover {
        background: #f8f9fa;
      }
      
      .airport-icon {
        font-size: 20px;
      }
      
      .airport-info {
        flex: 1;
        
        .airport-name {
          display: block;
          font-weight: 500;
          color: #2c3e50;
        }
        
        .airport-code {
          font-size: 12px;
          color: #7f8c8d;
        }
      }
    }
  }
}

// 动画
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style> 